// extracted by mini-css-extract-plugin
export default {"card":"style_card__4mSrf","children":"style_children__BAu61"};